import { htmlAllowedAttributes } from "@/helpers/application/html-allowed-attributes";
import { htmlAllowedEmptyTags } from "@/helpers/application/html-allowed-empty-tags";
import { paragraphFormats } from "@/helpers/application/paragraph-formats";
import { toolbarButtons } from "@/helpers/application/toolbar-buttons";

const state = {
  initCalled: false,
  initialized: false,
  loading: {
    happening: false,
    percent: 0,
    text: null
  },
  settings: Object.assign({
    drawer: true,
    darkTheme: false
  }, JSON.parse(localStorage.getItem("application_settings") || "{}")),

  currentStep: 1,

  twilioChat: false,

  froalaConfig: {
    requestWithCORS: true,
    iconsTemplate: "font_awesome_5",

    key: process.env.VUE_APP_FROALA_LICENSE_KEY,

    heightMin: 200,

    // disable features
    toolbarButtons: toolbarButtons,

    // paragraph formats
    paragraphFormat: paragraphFormats,

    // html attribute and tag settings
    htmlAllowedAttrs: htmlAllowedAttributes,
    htmlAllowedEmptyTags: htmlAllowedEmptyTags,

    // image upload
    imageUploadParam: "image",
    imageUploadURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`,
    imageUploadMethod: "POST",
    imageUploadRemoteUrls: true,

    // image manager
    imageManagerLoadURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`,
    imageManagerDeleteURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`, // just need somewhere that will return a 2xx to the delete
    imageManagerDeleteMethod: "DELETE"
  }
};

const actions = {
  initialize: async({ commit, dispatch }) => {
    commit("initCalled"); // this needs to happen here or we will end up double loading

    await dispatch("startSession");

    // all requests necessary for the app to run should happen here
    await commit("setLoading", {
      happening: true,
      percent: 0,
      text: "Retrieving your info..."
    });
    await dispatch("getUserInfo");

    await dispatch("getEveryFacility");

    await commit("setLoading", {
      happening: true,
      percent: 100,
      text: "Loading complete!"
    });
    await dispatch("sleep", 1250);

    await commit("setLoading", {
      happening: false
    });

    commit("initComplete");

    return Promise.resolve(true);
  },

  sleep: (ctx, ms) => {
    return new Promise(resolve => { setTimeout(resolve, ms); });
  },

  toggleDrawer: async({ commit }, newValue) => {
    await commit("setDrawer", newValue);
    commit("settingsUpdate");

    return Promise.resolve(true);
  },

  toggleDarkTheme: async({ commit }, newValue) => {
    await commit("setDarkTheme", newValue);
    commit("settingsUpdate");

    return Promise.resolve(true);
  },

  updateLoading: ({ commit }, payload) => {
    commit("setLoading", payload);

    return Promise.resolve(true);
  }
};

const mutations = {
  activateTwilioChat: (state) => {
    state.twilioChat = true;
  },

  endTwilioChat: (state) => {
    state.twilioChat = false;
  },

  initCalled: (state) => {
    state.initCalled = true;
  },

  initComplete: (state) => {
    state.initialized = true;
  },

  resetInit: (state) => {
    state.initialized = false;
    state.initCalled = false;
  },

  setCurrentStep: (state, currentStep) => {
    state.currentStep = currentStep;
  },

  setDrawer: (state, value) => {
    state.settings.drawer = value;
  },

  setDarkTheme: (state, value) => {
    state.settings.darkTheme = value;
  },

  settingsUpdate: (state) => {
    localStorage.setItem("application_settings", JSON.stringify(state.settings));
  },

  setLoading: (state, payload) => {
    state.loading.happening = payload.happening;
    state.loading.percent = payload.percent || 0;
    state.loading.text = payload.text || null;
  }
};

export default {
  state,
  actions,
  mutations
};
